// bootstrap 4 breakpoints
export const SMALL_DEVICES = 576;
export const MEDIUM_DEVICES = 768;
export const LARGE_DEVICES = 992;
export const EXTRA_LARGE_DEVICES = 1200;
export const MODAL_TRANSITION_TIMEOUT = 300;
export const MODAL_BACKDROP_TRANSITION_TIMEOUT = 150;
